import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const OTOLinkTransactionList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'ID',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'clientID',
				accessor: 'clientID',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'clientEmail',
				accessor: 'clientEmail',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'orderNumber',
				accessor: 'orderNumber',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'otoAmount',
				accessor: 'otoAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 130
			},
			{
				Header: 'authorizedAmount',
				accessor: 'authorizedAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 70
			},
			{
				Header: 'sellerAmount',
				accessor: 'sellerAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 90
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string,
				showOnMobile: true,
				translate: true
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			},
			{
				Header: 'otoOrderID',
				accessor: 'otoOrderID',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'chargeDate',
				accessor: 'chargeDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			},
			{
				Header: 'paymentType',
				accessor: 'paymentType',
				filterType: FilterType.enum,
				enumName: ENUMS.PAYMENT_METHOD_WITH_PROVIDER,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CREDIT_TRANSACTION_STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="otoLinkTransactions"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz"
			/>
			<DynamicList
				id={DYNAMICLISTS.OTO_LINK_FINANCE_TRANSACTIONS}
				columns={columns}
				fetchUrl={FINANCE.GET_OTO_LINK_TRANSACTIONS}
				exportName="otoLinkTransactions"
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</div>
	);
};

export default OTOLinkTransactionList;
